import { savedSearchSelected } from "../actions/data_hub_search";
import makeAsyncSelect from "../../../shared/make_async_select";

const valueSelector = (state) => state.dataHubSearch.selectedSavedSearch;
const optionsSelector = (state) => state.dataHubSearch.savedSearchOptions;

export default makeAsyncSelect(savedSearchSelected, "Saved Searches", valueSelector, optionsSelector, { clearable: false, placeholder: "Load a saved search" }, { "col-md-12": true });
